import bus from '@/utils/bus';

export default (editModal: any) => {
  bus.emit('modal.add', editModal);
};
